export default __webpack_public_path__ + "static/bubble-with-negative-values-6cf2b54d690e1c1f71ed1b9fdf7b0df6.png";